import { PowerSectionSmileyIcon } from '@/components/help-center/powers/power-gallery-view';
import PowerMentionText, { PowerMentionHtml } from '@/components/help-center/powers/PowerMentionText';
import { sanitizeCmsHtml, looksLikeHtml } from '@/lib/cms-html';
import {
  getPowerDocSectionsAt,
  type PowerDocSection,
  type PowerDocSectionPosition,
} from '@/lib/power-doc-section';
import { resolvePowerLore } from '@/lib/power-lore';
import type { PowerInfo } from '@/lib/powers-data';

function PowerDetailDocSectionBlock({ section }: { section: PowerDocSection }) {
  const subtitle = section.subtitle.trim() || 'Documentação';
  const title = section.title.trim();
  const description = section.description.trim();

  if (!title && !description) return null;

  return (
    <section className="border-b border-gray-100 bg-white py-14">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-8 flex items-center gap-3">
          <PowerSectionSmileyIcon code={section.smiley || 'read'} size="md" />
          <div>
            <p className="font-poppins text-xs font-semibold uppercase tracking-widest text-blue-500">
              {subtitle}
            </p>
            {title ? (
              <h2 className="font-poppins text-xl font-bold text-gray-900">{title}</h2>
            ) : null}
          </div>
        </div>

        {description ? (
          looksLikeHtml(description) ? (
            <PowerMentionHtml
              html={sanitizeCmsHtml(description)}
              className="font-inter text-base leading-relaxed text-gray-600 [&_p]:my-2"
            />
          ) : (
            <p className="font-inter text-base leading-relaxed text-gray-600">
              <PowerMentionText text={description} as="span" />
            </p>
          )
        ) : null}
      </div>
    </section>
  );
}

/** Renderiza as secções de documentação custom num slot da página do power. */
export default function PowerDocSectionsAt({
  power,
  position,
}: {
  power: PowerInfo;
  position: PowerDocSectionPosition;
}) {
  // Secções wiki «de lore» no slot after-overview são consumidas pelo bridge da Lore.
  const bridgedIds =
    position === 'after-overview' ? resolvePowerLore(power).bridgedDocSectionIds : [];
  const sections = getPowerDocSectionsAt(power, position, { excludeIds: bridgedIds });
  if (sections.length === 0) return null;

  return (
    <>
      {sections.map((section) => (
        <PowerDetailDocSectionBlock key={section.id} section={section} />
      ))}
    </>
  );
}
